import Nav from "../components/Nav";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";

export default function ProfileSection() {
  return (
    <>
      <div className="hero-bg">
        <Nav />

        <div className="hidden lg:flex flex-col items-center space-y-6 fixed right-24 top-[75%] -translate-y-1/2 z-50">
          {/* Social Icons */}
          <ul className="flex flex-col space-y-4">
            <li>
              <a
                href="https://www.facebook.com/people/Track-Itt-Verified/61558262340147/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full text-gray-100  border hover:bg-red-600 hover:text-white hover:border-red-500 transition duration-300"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/trackit_verified/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full text-gray-100  border hover:bg-red-600 hover:text-white hover:border-red-500 transition duration-300"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </li>
            <li>
              <a
                href="https://x.com/trackitsports"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full text-gray-100  border hover:bg-red-600 hover:text-white hover:border-red-500 transition duration-300"
              >
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
            </li>
          </ul>

          {/* Vertical Text */}
          <span className="text-xs tracking-widest uppercase rotate-180 [writing-mode:vertical-rl] text-gray-300">
            Follow Us
          </span>
        </div>

        <div className="mx-auto my-auto text-center flex flex-col py-48">
          <div className="text-outline text-white pb-2 text-7xl xl:text-8xl font-bold text-center mb-3 mt-20 xl:mt-64 text-shadow-md">
            Trackit Verified
          </div>
          <span className="uppercase text-3xl xl:text-5xl text-white mb-4 font-bold">
            Transfer & Collegiate Combine
          </span>
          <div className="mt-4">
            <Link
              className="group text-white bg-red-500 font-medium px-8 py-2 rounded-full text-base hover:bg-red-500/70 transition uppercase"
              to={"/events"}
            >
              Register for events
              <span className="inline-block transition-transform duration-300 group-hover:translate-x-1 pl-2">
                →
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
